

// Pseudo-code, not your actual file!
// nextButton.addEventListener('click', function() {
//   if (currentSlide === totalSlides - 1) {
//     goToSlide(0); // Loop to first slide
//   } else {
//     goToSlide(currentSlide + 1);
//   }
// });

// prevButton.addEventListener('click', function() {
//   if (currentSlide === 0) {
//     goToSlide(totalSlides - 1); // Loop to last slide
//   } else {
//     goToSlide(currentSlide - 1);
//   }
// });



// document.addEventListener('DOMContentLoaded', function () {
//   SwymCallbacks = window.SwymCallbacks || [];
//   SwymCallbacks.push(function () {
//     _swat.fetch(function (products) {
//       const countElement = document.getElementById('swym-wishlist-count');
//       if (countElement) {
//         countElement.textContent = products.length;
//       }
//     });
//   });
// });

// document.addEventListener('DOMContentLoaded', function () {
//   window.SwymCallbacks = window.SwymCallbacks || [];
//   SwymCallbacks.push(function () {
//     _swat.fetch(function (products) {
//       const countElements = document.querySelectorAll('.swym-wishlist-header-counter');
//       countElements.forEach(function (el) {
//         el.textContent = products.length;
//       });
//     });
//   });
// });


// document.addEventListener('DOMContentLoaded', function () {
//   window.SwymCallbacks = window.SwymCallbacks || [];
//   SwymCallbacks.push(function () {
//     _swat.fetch(function (products) {
//       // Filter out clearly broken or incomplete products
//       const validProducts = products.filter(function (item) {
//         return (
//           item &&
//           typeof item.du === 'string' && item.du.trim() !== '' &&
//           typeof item.dt === 'string' && item.dt.trim() !== '' &&
//           item.empi !== undefined && item.empi !== null
//         );
//       });

//       // Optional: deduplicate by empi instead of du (more robust)
//       const seen = new Set();
//       const uniqueProducts = validProducts.filter(p => {
//         if (seen.has(p.empi)) return false;
//         seen.add(p.empi);
//         return true;
//       });

//       // Update count in header
//       const countElements = document.querySelectorAll('.swym-wishlist-header-counter');
//       countElements.forEach(function (el) {
//         el.textContent = uniqueProducts.length;
//       });
//     });
//   });
// });


/* Loading Products Method 1 */

document.addEventListener('DOMContentLoaded', function () {
  const config = window.collectionLoadMore;
  if (!config) return;

  ;


          document.addEventListener('click', function (e) { 
            if (e.target && e.target.matches('#load-more-button')) { 

                const productGrid = document.querySelector(`#product-grid[data-id="${config.sectionId}"]`);
                const loadMoreButton = document.getElementById('load-more-button');
              
                if (!productGrid || !loadMoreButton) return;
              
                const hiddenProducts = [...productGrid.querySelectorAll('.hidden-product')];
                let currentIndex = 0
              
                const toShow = hiddenProducts.slice(currentIndex, currentIndex + config.loadCount);
      
                toShow.forEach(item => item.classList.remove('hidden-product'));
            
                currentIndex += config.loadCount;
            
                if (currentIndex >= hiddenProducts.length) {
                  loadMoreButton.style.display = 'none';
                }
            }
          
        });


});
 



/* Loading Products Method 2 */

// document.addEventListener('DOMContentLoaded', function () {
//   const config = window.collectionLoadMore;
//   if (!config) return;

//   const productGrid = document.getElementById('product-grid');
//   const loadMoreBtn = document.getElementById('load-more-button');

//   let productsLoaded = config.productsLoaded;
//   const loadCount = config.loadCount;

//   loadMoreBtn.addEventListener('click', function () {
//     const url = `/sections/load-more-products?collection_handle=${config.collectionHandle}&section_id=load-more-products&loaded_products=${productsLoaded}`;

//     fetch(url)
//       .then(res => res.text())
//       .then(html => {
//         const temp = document.createElement('div');
//         temp.innerHTML = html;
//         const items = temp.querySelectorAll('li.grid__item');

//         if (!items.length) {
//           loadMoreBtn.style.display = 'none';
//           return;
//         }

//         items.forEach(item => productGrid.appendChild(item));
//         productsLoaded += loadCount;
//       })
//       .catch(err => {
//         console.error('Load more error:', err);
//         loadMoreBtn.style.display = 'none';
//       });
//   });
// });




// document.addEventListener('DOMContentLoaded', function () {
//   const searchForm = document.getElementById('custom-search-form');
//   const collectionSelect = searchForm?.querySelector('select');
//   const collectionsSection = document.getElementById('product-grid');
//   const resultsSection = document.getElementById('search-results-section');
//   const resultsGrid = resultsSection?.querySelector('.search-product-grid');
//   const resultsHeading = document.getElementById('search-results-heading');
//   const loadMoreBtn = document.getElementById('load-more-button');
  

//   if (!collectionSelect || !collectionsSection || !resultsSection || !resultsGrid || !resultsHeading) return;

//   collectionSelect.addEventListener('change', function () {
//     const selectedCollectionHandle = collectionSelect.value;

    

//     if (!selectedCollectionHandle) {
//       collectionsSection.style.display = '';
//       resultsSection.style.display = 'none';
//       resultsGrid.innerHTML = '';
//       loadMoreBtn.style.display = 'block';
//       return;
//     }

//     fetch(`/collections/${selectedCollectionHandle}/products.json?limit=250`)
//       .then(response => response.json())
//       .then(data => {
//         const products = data.products;

//         if (products.length > 0) {
//           const html = products.map(product => {
//             const price = '₹' + parseInt(product.variants[0].price, 10).toLocaleString('en-IN');
//             const image = product.images[0]?.src || '';
//             return `
//               <div class="product-card">
//                 <a href="/products/${product.handle}">
//                   <img src="${image}" alt="${product.title}">
//                 </a>
//                 <div class="product-card__info">
//                   <a href="/products/${product.handle}">
//                     <p class="product-card__title">${product.title}</p>
//                   </a>
//                     <p class="product-card__price">${price}</p>
//                 </div>
//               </div>
//             `;
//           }).join('');

//           resultsHeading.textContent = collectionSelect.options[collectionSelect.selectedIndex]?.text || 'Products';
//           collectionsSection.style.display = 'none';
//           resultsSection.style.display = 'block';
//           resultsGrid.innerHTML = html;
//           loadMoreBtn.style.display = 'none';
//         } else {
//           resultsHeading.textContent = collectionSelect.options[collectionSelect.selectedIndex]?.text || 'Products';
//           collectionsSection.style.display = 'none';
//           resultsSection.style.display = 'block';
//           resultsGrid.innerHTML = '<p>No products found in this collection.</p>';
//           loadMoreBtn.style.display = 'none';
//         }
//       })
//       .catch(error => {
//         console.error('Error fetching collection:', error);
//         collectionsSection.style.display = '';
//         resultsSection.style.display = 'none';
//       });
//   });

//   // 🔁 Clear results when other filters are applied (e.g., checkboxes, dropdowns)
//   const filters = document.querySelectorAll('.facets__form input, .facets__form select');

//   filters.forEach(filter => {
//     filter.addEventListener('change', () => {
//       if (resultsSection && resultsGrid) {
//         resultsSection.style.display = 'none';
//         resultsGrid.innerHTML = '';
//       }
//       if (loadMoreBtn) {
//         loadMoreBtn.style.display = 'block';
//       }
//     });
//   });

// });



document.addEventListener('DOMContentLoaded', function () {
  var $carousel = $('.testimonials-carousel');

  // Initialize Slick
  $carousel.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    arrows: true,
    dots: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  });

  // function updateArrows() {
  //   var $prevArrow = $carousel.find('.slick-prev');
  //   var $nextArrow = $carousel.find('.slick-next');
  //   var current = $carousel.slick('slickCurrentSlide');
  //   var slideCount = $carousel.slick('getSlick').slideCount;
  //   var slidesToShow = $carousel.slick('getSlick').options.slidesToShow;

  //   // Disable previous button if on first slide
  //   if (current === 0) {
  //     $prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
  //   } else {
  //     $prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
  //   }

  //   // Disable next button if on (last possible start slide)
  //   if (current >= slideCount - slidesToShow) {
  //     $nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
  //   } else {
  //     $nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
  //   }
  // }

  // // Update arrows initially and on every slide change
  // updateArrows();
  // $carousel.on('afterChange', updateArrows);
});




document.addEventListener('DOMContentLoaded', function () {
  const searchForm = document.getElementById('custom-search-form');
  const searchInput = searchForm ? searchForm.querySelector('input[type="search"]') : null;
  const collectionSelect = searchForm ? searchForm.querySelector('select') : null;
  const collectionsSection = document.getElementById('product-grid');
  const resultsSection = document.getElementById('search-results-section');
  const resultsGrid = resultsSection ? resultsSection.querySelector('.search-product-grid') : null;
  const resultsHeading = document.getElementById('search-results-heading');
  const loadMoreBtn = document.getElementById('load-more-button');

  if (!searchForm || !searchInput || !collectionSelect || !collectionsSection || !resultsSection || !resultsGrid || !resultsHeading) {
    console.error('Custom search: Required elements not found.');
    return;
  }

  // Handle collection change
  collectionSelect.addEventListener('change', function () {
    const selectedCollectionHandle = collectionSelect.value;

    if (!selectedCollectionHandle) {
      collectionsSection.style.display = '';
      resultsSection.style.display = 'none';
      resultsGrid.innerHTML = '';
      loadMoreBtn.style.display = 'block';
      return;
    }

    const query = searchInput.value.trim().toLowerCase();
    searchProduct(query, resultsGrid, selectedCollectionHandle);
  });

  // Search & filter function
  function searchProduct(query, resultsGrid, selectedCollectionHandle) {
    fetch(`/collections/${(selectedCollectionHandle || 'all')}?sections=filter-featured-collection`)
      .then(res => res.json())
      .then(html => {
        collectionsSection.style.display = 'none';
        resultsSection.style.display = 'block';
        resultsGrid.innerHTML = html['filter-featured-collection'];

        const products = document.querySelectorAll('.contains-card--product li');
        products.forEach(li => {
          li.style.display = 'block';
        });

        if (!products.length) return;

        let matchCount = 0;
        products.forEach(li => {
          const link = li.querySelector('.full-unstyled-link');
          if (link) {
            const text = link.textContent.toLowerCase();
            if (!text.includes(query)) {
              li.style.display = 'none';
            } else {
              matchCount++;
            }
          }
        });

        if (matchCount === 0) {
          resultsGrid.innerHTML = '<p>No products found.</p>';
        }

        loadMoreBtn.style.display = 'none';
      })
      .catch(error => {
        console.error('Error fetching products:', error);
        collectionsSection.style.display = '';
        resultsSection.style.display = 'none';
      });
  }

  // Search form submit
  searchForm.addEventListener('submit', function (e) {
    e.preventDefault();
    const query = searchInput.value.trim().toLowerCase();
    const selectedCollectionHandle = collectionSelect.value;
    searchProduct(query, resultsGrid, selectedCollectionHandle);
  });

  // Reset when search is cleared
  searchInput.addEventListener('input', function () {
    const query = searchInput.value.trim();
    const selectedCollectionHandle = collectionSelect.value;

    if (query.length === 0) {
      if (!selectedCollectionHandle) {
        collectionsSection.style.display = '';
        resultsSection.style.display = 'none';
        resultsGrid.innerHTML = '';
        loadMoreBtn.style.display = 'block';
      } else {
        collectionSelect.dispatchEvent(new Event('change'));
      }
    }
  });

  // Reset results if other filters are applied
  const filters = document.querySelectorAll('.facets__form input, .facets__form select');
  filters.forEach(filter => {
    filter.addEventListener('change', () => {
      resultsSection.style.display = 'none';
      resultsGrid.innerHTML = '';
      loadMoreBtn.style.display = 'block';
    });
  });
});















































